import { z } from 'zod';

export const periodStatusSchema = z.enum(['OPEN', 'CLOSED']);
export type PeriodStatus = z.infer<typeof periodStatusSchema>;

export const periodResponseSchema = z.object({
  id: z.string(),
  year: z.number().int(),
  month: z.number().int().min(1).max(12),
  status: periodStatusSchema,
  closedAt: z.string().nullable(),
  createdAt: z.string(),
});
export type PeriodResponse = z.infer<typeof periodResponseSchema>;
